import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Select} from "antd";
import ApiService from "../../core/service/ApiService";

export default function RoleSelectBox(props)
{
    const {t} = useTranslation();

    const [roles, setRoles] = useState([])

    const getRoles = async () =>
    {
        const response = await ApiService.Role.GetRoleList();
        if (response.success)
        {
            setRoles(response.data)
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    return (
        <>
            <Select
                mode="single"
                allowClear
                options={roles}
                fieldNames={{
                    label: 'name',
                    value: 'id'
                }}
                {...props}
            />
        </>
    )
}
